(ns ductile.ui.deframe.events
  (:require-macros [ductile.ui.deframe.events])
  (:require [ductile.ui.deframe :as-alias deframe]
            [re-frame.core :as rf]))

(defn ^:private make-event-handler
  [name handler-fn]
  (fn [ctx event]
    (when (not (<= 1 (count event) 2))
      (throw (ex-info "event vector must can only have a single map arg" {:args (rest event)})))
    (handler-fn ctx (second event))))

(defn register-event! [name handler-fn]
  (rf/reg-event-fx name (make-event-handler name handler-fn)))

(defn register-effect! [name handler-fn]
  (rf/reg-fx name (fn [args] (apply handler-fn args))))

